import { useState } from "react"
import "./index.scss"
function CoreProducts() {
  const list = [
    {
      id: 1,
      title: "师爷AI",
      content: "提供一键生成尽调报告、垂直领域专业应答、智能风险分析等核心功能，助力金融机构高效决策",
      avatar: require("../../assets/avatar1.png"),
      img: require("../../assets/img1.png"),
      hoverAvatar: require("../../assets/avatar11.png"),
    },
    {
      id: 2,
      title: "百昌估值地图",
      content: "输入具体位置，即可1秒查询周边10公里内各类房产及土地的历史交易价格及周边19项配套信息，并可生成“大数据智能评估报告”",
      avatar: require("../../assets/avatar2.png"),
      img: require("../../assets/img2.png"),
      hoverAvatar: require("../../assets/avatar22.png"),
    },
    {
      id: 3,
      title: "百昌找律师",
      content: "整合全国诉讼数据，经系统大数据算法处理，交叉验证 、挖掘匹配更合适的服务商",
      avatar: require("../../assets/avatar3.png"),
      img: require("../../assets/img3.png"),
      hoverAvatar: require("../../assets/avatar33.png"),
    },
    {
      id: 4,
      title: "百昌数智",
      content: "集资产管理、招租、合同、数据分析、租客预警及业态分析等功能于一体，为提升运营效率和优化商业决策提供数据支持",
      avatar: require("../../assets/avatar4.png"),
      img: require("../../assets/img4.png"),
      hoverAvatar: require("../../assets/avatar44.png"),
    },
  ]
  const [currentId, setCurrentId] = useState(1)
  function handleMouseEnter(id) {
    setCurrentId(id)
  }
  return (
    <div className="coreProducts-container">
      <div className="subtitle">核心产品</div>
      <div className="title">CORE PRODUCT</div>
      <div className="avatar-row">
        {list.map((items) => {
          if (items.id === currentId) {
            return (<div key={items.id} className="avatar-container">
              <img onMouseEnter={() => handleMouseEnter(items.id)} onClick={() => handleMouseEnter(items.id)} style={{ cursor: "pointer" }} className="img" src={items.hoverAvatar}></img>
            </div>)
          } else {
            return (<div key={items.id} className="avatar-container">
              <img onMouseEnter={() => handleMouseEnter(items.id)} onClick={() => handleMouseEnter(items.id)} style={{ cursor: "pointer" }} className="img" src={items.avatar}></img>
            </div>)
          }
        }
        )}
      </div>
      <div className="coreProducts-info">
        {list.map((item, index) => {
          if (item.id === currentId) {
            return (
              <div key={index} className="coreProducts-item">
                <div className="info-left">
                  <img className="img" src={item.img}></img>
                </div>
                <div className="info-right">
                  <div className="title">{item.title}</div>

                  <div className="product-describe">
                    {item.content}
                  </div>
                </div>
              </div>
            )
          }
        })}

      </div>
    </div>
  )
}
export default CoreProducts